import React, { useState, useEffect, useRef, useMemo, Fragment } from 'react';
import { Mix } from '@ant-design/plots';
import LineProgress from '../common/lineProgress';
import userNumBg from "../../../images/aiReport/userNumBg.png";
import fh from "../../../images/aiReport/fh.png";

import { mentalityList, titleList, unparam } from 'utils/common';


const ResultApp = (props) => {
    const queryString = unparam(window.location.search);
    let langEn = queryString.lang === 'en_us';
    let title = langEn ? titleList['社会平均分'] : '社会平均分';
    let title1 = langEn ? titleList['候选人得分'] : '候选人得分';
    const detail = props.data || {};
    let isTwoFactor = detail.factorResultItems && detail.factorResultItems.length > 2;
    const userInfo = props.userInfo || {};

    const [isLoading, setIsLoading] = useState(true);
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        if(detail.factorResultItems && detail.factorResultItems.length > 0){
          detail.factorResultItems.forEach(ele => {
            ele.name = langEn ? mentalityList[ele.name] : ele.name;
          });
          setChartData(detail.factorResultItems)
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
    },[detail])
    
    const config = {
        height: 280,
        // appendPadding: 8,
        tooltip: {
          shared: true,
        },
        syncViewPadding: true,
        plots: [
          {
            type: 'column',
            options: {
              data: chartData,
              xField: 'name',
              yField: 'userScore',
              yAxis: {
                tickCount: 6,
                min: 0,
                max: 5,
                label: {
                  style: {
                      fill: 'rgba(0,0,0,0.65)',
                      fontSize: 14,
                      fontFamily: 'PingFang SC',
                  },
                },
                grid: {
                  line: {
                    style: {
                      stroke: '#C7D5EF',
                      lineWidth: 0,
                      lineDash: [5, 5],
                    }
                  }
                },
              },
              xAxis: {
                label: {
                    offset: 18,
                    autoEllipsis:true,
                    autoHide: false,
                    autoRotate: true,
                    style: {
                        fill: '#474C66',
                        fontSize: 14,
                        fontFamily: 'PingFang SC',
                    },
                },
                line: {
                  style: {
                    stroke: '#C7D5EF',
                    lineWidth: 0,
                    lineDash: [5, 5],
                  }
                },
              },
              meta: {
                name: {
                  sync: true,
                },
                userScore: {
                  alias: title1,
                },
              },
              color: 'l(90) 0:#BB4BFF 1:#5473FF',
              maxColumnWidth: chartData.length === 9 ? 20 : 40,
              columnWidthRatio: 0.4,
              columnStyle: {
                  radius: chartData.length === 9 ? [20, 20, 1, 1] : [12, 12, 12, 12], // 设置柱子圆角
              },
            },
          },
          {
            type: 'line',
            options: {
              data: chartData,
              xField: 'name',
              yField: 'avgScore',
              xAxis: false,
              yAxis: {
                tickCount: 6,
                min: 0,
                max: 5,
                label: {
                  style: {
                      fill: 'transparent',
                      fontSize: 14,
                      fontFamily: 'PingFang SC',
                  },
                },
                grid: {
                  line: {
                    style: {
                      stroke: '#C7D5EF',
                      lineWidth: 0.5,
                      lineDash: [5, 5],
                    }
                  }
                },
              },
              xAxis: {
                label: {
                    offset: 18,
                    autoEllipsis:true,
                    autoHide: false,
                    autoRotate: true,
                    style: {
                        fill: 'transparent',
                        fontSize: 14,
                        fontFamily: 'PingFang SC',
                    },
                },
                line: {
                  style: {
                    stroke: '#C7D5EF',
                    lineWidth: 0,
                    lineDash: [5, 5],
                  }
                },
              },
              label: null,
              meta: {
                avgScore: {
                  alias: title,
                },
              },
              color: '#FDAE21',
              annotations: chartData.map((d) => {
                return {
                  type: 'dataMarker',
                  position: d,
                  line: null,
                  point: {
                    size: 5, // 点的大小
                    shape: 'circle', // 点的形状
                    style: {
                        fill: '#FDAE21', // 点的填充色
                        stroke: '#FDAE21', // 点的边框色
                        lineWidth: 0, // 点的边框宽度
                    },
                  },
                };
              }),
            },
          },
          
        ],
    };

    const renderEvaluate = useMemo(() => {
        return (
            <div className="result-evaluate-cont">
                {detail.remind && <div className="result-evaluate-wran"><i className="iconfont icon-a-lujing78120"></i>{detail.remind || ''}</div>}
                {/* <div className="result-evaluate-cont-user-info">{userInfo.userName || '该候选人'}的测评总分为 ：<span>{detail.totalScore || 0}</span>分，阳性项目数为：<span>{detail.positiveItems || 0}</span>。</div> */}
                {detail.overallEvaluate || ''}
                {/* <div className="result-evaluate-tip">注：阳性项目指受测者自觉有症状的项目。</div> */}
            </div>
        );
    }, [detail]);

    const renderEvaluateList = useMemo(() => {
        if(detail.factorResultItems && detail.factorResultItems.length > 0){
          return (
            <div className="mental-health-right">
                {detail.factorResultItems.map((item) => {
                    return (
                        <div className="mental-evaluate-li">
                            <div className="mental-evaluate-li-top">
                                <span className="mental-evaluate-li-name">{item.name || ''}：</span>
                                {/* <div className="mental-evaluate-li-num">
                                    <img src={userNumBg}/>
                                    <p>{item.userScore || 0}<span>分</span></p>
                                </div> */}
                                <div className="mental-evaluate-li-num1">
                                    {/* <img src={userNumBg}/> */}
                                    <p className={item.riskLevel == '低风险' ? 'c52C41B' : item.riskLevel == '高风险' ? 'ff4d4f' : 'fdae21'}>{item.riskLevel || ''}</p>
                                </div>
                            </div>
                            <div className="mental-evaluate-li-dec">{item.perform || ''}</div>
                        </div>
                    );
                })}
            </div>
          );
        } else {
          return nulll
        }
    }, [detail]);

    const renderEvaluateListTwo = useMemo(() => {
      if(detail.factorResultItems && detail.factorResultItems.length > 0){
        return detail.factorResultItems.map((item) => {
          return (
              <div className="mental-evaluate-li mental-evaluate-li-two">
                  <LineProgress percent={item.userScore || 0} averageNum={item.avgScore || 0}/>
                  <div className="mental-evaluate-li-top">
                      <span className="mental-evaluate-li-name">{item.name || ''}：</span>
                      <div className="mental-evaluate-li-num1">
                          <p className={item.riskLevel == '低风险' ? 'c52C41B' : item.riskLevel == '高风险' ? 'ff4d4f' : 'fdae21'}>{item.riskLevel || ''}</p>
                      </div>
                  </div>
                  <div className="mental-evaluate-li-dec">{item.perform || ''}</div>
              </div>
          );
        });
      } else {
        return nulll
      }
  }, [detail]);

    if(isLoading) return null;

    return (
        <div className="result-wrap">
            <div className="readingTitleWrap">
                <div className="readingTitleLeft">
                    <div className="readingTitleLeftIcon">
                        <span></span>
                        <span></span>
                    </div>
                    <span>心理测验</span>
                    <Fragment>
                        <div className="readingTitleTab active">
                            {isTwoFactor ? <i style={{background: '#FDAE21'}}></i> : <span className='iconfont icon-sanjiao2'></span>}
                            <p>{title}</p>
                        </div>
                        <div className="readingTitleTab">
                            {isTwoFactor ? <i></i> : <span className='iconfont icon-sanjiao1'></span>}
                            <p>{title1}</p>
                        </div>
                    </Fragment>
                </div>
                <div className="readingTitleRight">

                </div>
            </div>
            {/*内容部分*/}
            <div className="result-padding">
                {isTwoFactor ? (
                  <div className={`mental-health${detail.factorResultItems && detail.factorResultItems.length > 3 ? ' mental-health-column' : ''}`}>
                    <div className="mental-health-left">
                        <div className="mental-health-chart">
                            <Mix {...config} />
                        </div>
                    </div>
                    {renderEvaluateList}
                  </div>
                ) : (
                  <div className={`mental-health mental-health-column-two`}>
                    {renderEvaluateListTwo}
                  </div>
                )}

                <div className="result-evaluate">
                    <img src={fh} className="result-evaluate-d"/>
                    <div className="result-evaluate-tit">综合评价</div>
                    {renderEvaluate}
                </div>

            </div>
        </div>
    );
}

export default ResultApp;
